// extracted by mini-css-extract-plugin
export default {"incodeSmsContent":"incode-sms-container__incode-sms-content__OcpIU"};